<template>
  <div>
    <div class="content-card mb-4">
      <div class="card-header" @click="toggleBranchesView">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="card-title m-0">
            <i class="ni ni-building mr-2"></i>Branches
          </h5>
          <i class="toggle-icon" :class="showBranches ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
        </div>
      </div>
      
      <div class="card-body" v-if="showBranches">
        <div v-if="branches && branches.length" class="modern-branch-grid">
          <div 
            v-for="branch in branches" 
            :key="branch._id" 
            class="branch-card"
            :class="{'main-branch': branch.is_main, 'shadow-sm': !branch.is_main}"
          >
            <div class="branch-card-header">
              <h5>{{ branch.name }}</h5>
              <span v-if="branch.is_main" class="main-badge">Main</span>
            </div>
            
            <div class="branch-card-body">
              <div v-if="branch.address" class="branch-info-item">
                <i class="ni ni-pin-3 text-danger"></i>
                <span>{{ branch.address }}</span>
              </div>
              <div v-if="branch.phone" class="branch-info-item">
                <i class="ni ni-mobile-button text-primary"></i>
                <span>{{ branch.phone }}</span>
              </div>
            </div>
            
            <div class="branch-card-footer">
              <button class="btn btn-sm btn-info" @click.stop="$emit('view', branch)">
                <i class="fa fa-eye mr-1"></i> View
              </button>
              <button class="btn btn-sm btn-primary" @click.stop="$emit('edit', branch)">
                <i class="fa fa-pencil mr-1"></i> Edit
              </button>
              <button 
                v-if="!branch.is_main" 
                class="btn btn-sm btn-success" 
                @click.stop="$emit('set-main', branch)"
              >
                <i class="fa fa-star mr-1"></i> Set Main
              </button>
              <button 
                class="btn btn-sm btn-danger" 
                @click.stop="$emit('delete', branch)"
              >
                <i class="fa fa-trash mr-1"></i>
              </button>
            </div>
          </div>
        </div>
        
        <div v-else class="no-branches-modern">
          <div class="text-center p-4">
            <i class="ni ni-building text-muted mb-3" style="font-size: 4rem;"></i>
            <h5>No Branches Added Yet</h5>
            <p class="text-muted">Add branches to manage multiple locations for this business</p>
          </div>
        </div>
        
        <div class="text-center mt-3">
          <base-button @click.stop="$emit('add')" type="primary" icon="fa fa-plus">
            Add New Branch
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton";

export default {
  name: 'BranchesList',
  components: {
    BaseButton
  },
  props: {
    branches: {
      type: Array,
      default: () => []
    },
    showBranches: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleBranchesView() {
      this.$emit('toggle');
    }
  }
}
</script>

<style scoped>
/* Content Card Styles */
.content-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  transition: all 0.3s ease;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
}

.content-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 3rem 0 rgba(136, 152, 170, 0.2);
}

.content-card .card-header {
  background: linear-gradient(87deg, #11cdef, #1171ef) !important;
  border-bottom: none;
  padding: 1.3rem 1.5rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.content-card .card-header::before {
  content: '';
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: rgba(255, 255, 255, 0.1);
  width: 120px;
  height: 120px;
  border-radius: 50%;
  z-index: 0;
}

.content-card .card-header::after {
  content: '';
  position: absolute;
  bottom: -20px;
  left: -20px;
  background-color: rgba(255, 255, 255, 0.05);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  z-index: 0;
}

.content-card .card-body {
  padding: 1.5rem;
}

.toggle-icon {
  transition: all 0.3s ease;
  color: white;
  font-size: 1.2rem;
  z-index: 1;
  position: relative;
}

.card-title {
  font-weight: 600;
  font-size: 1.1rem;
  color: white;
  margin-bottom: 0 !important;
  z-index: 1;
  position: relative;
}

.card-title i {
  color: rgba(255, 255, 255, 0.8);
}

.modern-branch-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.branch-card {
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #eaecef;
  overflow: hidden;
  transition: all 0.3s ease;
}

.branch-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(149, 157, 165, 0.2) !important;
}

.main-branch {
  border-top: 4px solid #2dce89;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

.branch-card-header {
  padding: 1rem;
  border-bottom: 1px solid #f0f0f0;
  background-color: #f8f9fe;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.branch-card-header h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #32325d;
}

.main-badge {
  background-color: #2dce89;
  color: #fff;
  border-radius: 30px;
  padding: 0.25rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.branch-card-body {
  padding: 1rem;
}

.branch-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.branch-info-item i {
  margin-right: 0.75rem;
  font-size: 1rem;
  margin-top: 0.25rem;
}

.branch-info-item span {
  font-size: 0.875rem;
  color: #525f7f;
  line-height: 1.5;
}

.branch-card-footer {
  padding: 0.75rem 1rem;
  border-top: 1px solid #f0f0f0;
  background-color: #f8f9fe;
  display: flex;
  gap: 0.5rem;
}

.no-branches-modern {
  background-color: #fff;
  border: 2px dashed #e9ecef;
  border-radius: 8px;
  margin: 1rem 0;
}
</style>
